import { z } from 'zod';
import { buildCsvValidator, } from './streamCsvValidation';
export const buildZodCsvValidator = (zodSchema, options) => {
    const rawSchema = zodSchema instanceof z.ZodObject
        ? Object.entries(zodSchema.shape).reduce((headerZodSchema, [header, zodStrSchema]) => {
            headerZodSchema[header] = (val) => {
                zodStrSchema.parse(val);
            };
            return headerZodSchema;
        }, {})
        : zodSchema._zod.def.items.map((zodStrSchema) => (val) => {
            zodStrSchema.parse(val);
        });
    return buildCsvValidator(rawSchema, {
        ...options,
        errorExtractor: (err) => {
            if (err instanceof z.ZodError) {
                return err.issues.map(({ message }) => message);
            }
            return ['Unknown'];
        },
    });
};
//# sourceMappingURL=buildZodCsvValidator.js.map